var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRightArrowUpBgIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 26,
    viewBox: "0 0 27 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.16 5.34065C25.3885 9.56915 25.3885 16.4328 21.16 20.6613C16.9315 24.8898 10.0678 24.8898 5.83934 20.6613C1.61085 16.4328 1.61085 9.56915 5.83934 5.34065C10.0678 1.11216 16.9315 1.11215 21.16 5.34065ZM10.7726 10.3199C10.7726 10.5497 10.8645 10.7488 11.0101 10.8944C11.1556 11.0399 11.3548 11.1319 11.5846 11.1319L14.2197 11.1319L10.244 15.1076C9.92996 15.4216 9.92996 15.9425 10.244 16.2566C10.5581 16.5707 11.079 16.5707 11.3931 16.2566L15.3688 12.2809L15.3688 14.9161C15.3688 15.3604 15.7365 15.7281 16.1808 15.7281C16.6251 15.7281 16.9928 15.3604 16.9928 14.9161L16.9928 10.3199C16.9928 9.87556 16.6251 9.50787 16.1808 9.50787L11.5846 9.50787C11.1403 9.50787 10.7726 9.87556 10.7726 10.3199Z",
    fill: "#050505"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightArrowUpBgIcon);
export default __webpack_public_path__ + "static/media/rightArrowUpBgIcon.78b87fd7f05b419ee00bb572c8685e12.svg";
export { ForwardRef as ReactComponent };